module.exports = __webpack_public_path__ + "img/records-empty@3x.f11f3578.png";